import { render, staticRenderFns } from "./mobile-header.vue?vue&type=template&id=3cd67073&"
import script from "./mobile-header.vue?vue&type=script&lang=js&"
export * from "./mobile-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports